// extracted by mini-css-extract-plugin
module.exports = {"button":"add-button_button__1UkAc","icon":"add-button_icon__2M688"};